import { Link } from "react-router-dom";

/**
 * FarmersStandaloneFooter — deep-green partner-site footer.
 *
 * Matches the "Rhythm of Modern Farming" mock: solid #0F3D2A bar, cream
 * text, centered brand tag + link row + copyright.
 */
export default function FarmersStandaloneFooter({ basePath = "/" }) {
  const natureUrl = process.env.REACT_APP_NATUREPULSE_URL || "https://naturepulse.net";
  const to = (sub) => (basePath === "/" ? sub : `${basePath}${sub}`);
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="farmers-standalone-footer"
      className="mt-16 bg-[#0F3D2A] text-[#F1EDDD]"
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-8 text-center">
        <div className="text-sm">
          A <a href={natureUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white">
            NaturePulse.net™
          </a> Partner Site
        </div>
        <div className="mt-3 text-sm flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <Link to={to("/privacy")} className="hover:text-white">Privacy Policy</Link>
          <span aria-hidden>|</span>
          <Link to={to("/terms")} className="hover:text-white">Terms of Service</Link>
          <span aria-hidden>|</span>
          <Link to={to("/contact")} className="hover:text-white">Contact</Link>
          <span aria-hidden>|</span>
          <Link to={to("/api")} className="hover:text-white">API Access</Link>
        </div>
        <div className="mt-3 text-xs opacity-80">
          © {year} FarmersPulse.com™. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
